import "./update.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Select from "react-select";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { lateformInputs } from "../../formSource";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];
const formatApiDateToInput = (apiDate) => {
  if (!apiDate) return "";
  const dateObj = new Date(apiDate);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
const LateFormUpdate = ({ title }) => {
  const location = useLocation();
  const LFId = location.pathname.match(/\/update-late-form\/(\d+)/)?.[1];
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [inputValues, setInputValues] = useState("");
  let [token] = useState(localStorage.getItem("token"));
  const navigate = useNavigate();

  const redirectToLogin = () => {
    toast.warning("Please login first to access this page", {
      autoClose: 2000,
      onClose: () => (window.location.href = "/"),
    });
  };

  // In your fetchLform function, make sure to format the date properly
  useEffect(() => {
    const fetchLform = async () => {
      try {
        const response = await fetch(`${serverUrl}/student/lform/${LFId}`, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch late form data");
        }
        const data = await response.json();

        // Format the date properly
        const formattedData = {
          ...data.data,
          date: formatApiDateToInput(data.data.date),
        };

        setInputValues(formattedData);
        const status = data.data.Status;
        setSelectedStatus(
          status === 1
            ? { value: status, label: "Active" }
            : { value: status, label: "Inactive" }
        );

        localStorage.setItem("quizData", JSON.stringify(data));
      } catch (error) {
        console.error(error);
        toast.error("Error loading late form data");
      }
    };

    if (LFId) {
      fetchLform();
    }
  }, [LFId]);
  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues({
      ...inputValues,
      status: selectedOption.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const adminData = JSON.parse(localStorage.getItem("admindata"));
    const formData = new FormData();
    formData.append("center_id", localStorage.getItem("center_id"));
    formData.append("student_id", localStorage.getItem("student_id"));
    formData.append("user_id", adminData.id);
    formData.append("reason", inputValues.reason);
    formData.append("time", inputValues.time);
    formData.append("date", inputValues.date);
    formData.append("status", inputValues.status || 1);

    const toastId = toast.loading("Updating late form...");

    try {
      const response = await fetch(`${serverUrl}/student/upd_lform/${LFId}`, {
        method: "PUT",
        body: formData,
      });

      const data = await response.json();
      console.log("Response from API", data);

      if (!response.ok) {
        throw new Error(data.message || "Failed to update late form");
      }

      toast.update(toastId, {
        render: "Late form updated successfully!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });

      setTimeout(() => {
        navigate("/student-attendance/late-form");
      }, 2000);
    } catch (error) {
      console.log(error);
      toast.update(toastId, {
        render: error.message || "Error updating late form",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  return (
    <>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="top">
              <h1>{title}</h1>
            </div>
            <div className="bottom">
              <div className="right">
                <form onSubmit={handleUpdate}>
                  {lateformInputs.map((input) => (
                    <div className="formInput" key={input.id}>
                      <label>{input.label}</label>
                      {input.fieldName === "status" ? (
                        <Select
                          options={statusOptions}
                          name={input.fieldName}
                          value={selectedStatus}
                          onChange={handleStatusSelectChange}
                          required
                        />
                      ) : (
                        <input
                          type={input.type}
                          placeholder={input.placeholder}
                          name={input.fieldName}
                          value={inputValues[input.fieldName] || ""}
                          onChange={handleInputChange}
                          required
                        />
                      )}
                    </div>
                  ))}
                  <div style={{ clear: "both" }} className="formUpdate">
                    <button style={{ float: "right" }} type="submit">
                      Update
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      style={{ float: "right" }}
                      onClick={() => navigate(`/student-attendance/late-form`)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default LateFormUpdate;
